import LegalPage from '@components/legal-page';
import { createLegalPageStaticProps } from '@components/legal-page/static-props';
import type { LegalPageProps } from '@components/legal-page/static-props';

const COOKIE_PAGE_SLUG = 'cookie-policy';

const CookiePolicy = ({ page }: LegalPageProps) => {
  if (!page) return null;
  return <LegalPage page={page} />;
};

export const getStaticProps = createLegalPageStaticProps(COOKIE_PAGE_SLUG);

export default CookiePolicy;
